module.exports = __webpack_public_path__ + "assets/general-black.6aad3a1d.svg";